import React, { useEffect, useState } from 'react';
import pro from '../../assets/images/preloader-image.png'

const Preloader = ({ onLoadComplete }) => {
    return (
        <div className="preloader">
            <div className="loading-container">
                <div className="loading-image">
                    <img src={pro} alt="logo" />
                    <div className="logo-text">
                        <h1>Uniqo</h1>
                    </div>
                </div>
            </div>
        </div>
    );
};

const App = () => {
    const [loading, setLoading] = useState(true);

    useEffect(() => {

        const timer = setTimeout(() => {
            setLoading(false);
        }, 2000);

        return () => clearTimeout(timer);
    }, []);

    return (
        <>
            {loading ? <Preloader /> : <></>}
        </>
    );
};

export default App;